import React, {useEffect, useRef} from "react";

import {useDrag, useDrop} from "react-dnd";
import services from "../../../services";

const type = "DragableBodyRow";

const RowDragInDrop = ({
  children,
  data,
  atualizarPastasDragInDrop,
  itensSelecionados,
  setItensSelecionados,
  style
}) => {
  const ref = useRef();
  const [{isDragging}, dragRef] = useDrag({
    type: type,
    item: data,
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [, dropRef] = useDrop({
    accept: type,
    drop(item, monitor) {
      if (item.id == data.id) {
        return;
      }

      if (item.id == services.storage.get('IDPASTA')) {
        return;
      }

      if (itensSelecionados?.length > 0) {
        itensSelecionados.forEach((item) => { 
          let request = {
            
            items: [
              {
                idPastaArquivo: item.id,
                tipo: item.tipo,
              },
            ],
            idParent: data.id? data.id : services.storage.get('IDPASTA'),
          };

          atualizarPastasDragInDrop(request);
          setItensSelecionados([]);
        });
      } else { 
        let request = {
          items: [
            {
              idPastaArquivo: item.id,
              tipo: item.tipo,
            },
          ],
          idParent: data.id? data.id : services.storage.get('IDPASTA'),
        };

        atualizarPastasDragInDrop(request);
        setItensSelecionados([]);
      }
    },
  });

  dragRef(dropRef(ref));

  return (
    <tr ref={ref} isDragging={isDragging} style={style}>
      {children} 
    </tr>
  );
}; 
export default RowDragInDrop;
